import React, { useState, useEffect } from 'react';

import { Checkbox, Divider } from 'antd';

const CheckboxGroup = Checkbox.Group;

const pvfOptions = ['-', '1', '2', '3'];

const PvfFilterCheckboxes = ({
  filterValue,
  tableFilterData,
  setTableFilterData,
}) => {
  const [checkedList, setCheckedList] = useState(pvfOptions);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(true);

  useEffect(() => {
    if (filterValue) {
      const newTableFilterData = Object.assign({}, tableFilterData, {
        [filterValue]: checkedList,
      });
      setTableFilterData(newTableFilterData);
    }
  }, [checkedList, filterValue]);

  const onChange = (list) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < pvfOptions.length);
    setCheckAll(list.length === pvfOptions.length);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? pvfOptions : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  return (
    <div>
      <Checkbox
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        checked={checkAll}
      >
        Check all
      </Checkbox>
      <Divider />
      <CheckboxGroup
        options={pvfOptions}
        value={checkedList}
        onChange={onChange}
      />
    </div>
  );
};

export default PvfFilterCheckboxes;
